import type { WasteMovementFormValues, WasteMovementStringFieldKey } from "../model/formValues";

const DEFAULT_TO_FORM: Record<string, WasteMovementStringFieldKey> = {
    RegEwcCodeId: "regEwcCodeId",
    RegDisposalRecoveryCodeId: "regDisposalRecoveryCodeId",
    MunicipalFlagId: "municipalFlagId",
    DegradableFlagId: "degradableFlagId",
    RegPhysicalStateId: "regPhysicalStateId",
    RegSourceActivityId: "regSourceActivityId",
    RegPreTreatmentId: "regPreTreatmentId",
};

export function defaultFieldKeyToFormKey(fieldKey: string): WasteMovementStringFieldKey | null {
    return DEFAULT_TO_FORM[fieldKey] ?? null;
}

export function mapPrefillToFormValues(
    prefill: Record<string, string | null>
): Partial<Pick<WasteMovementFormValues, WasteMovementStringFieldKey>> {
    const result: Partial<Pick<WasteMovementFormValues, WasteMovementStringFieldKey>> = {};
    for (const [key, val] of Object.entries(prefill)) {
        const formKey = defaultFieldKeyToFormKey(key);
        if (formKey && val) {
            result[formKey] = val;
        }
    }
    return result;
}
